import { Injectable } from '@angular/core';
import { User } from './user';
import { AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrincipalService implements Resolve<string[]> {
  private user: User;

  constructor(private authenticationService: AuthenticationService) {
    this.authenticationService.currentUser.subscribe(data => {
      this.setUser(data);

      // TODO: BORRAR
      // this.setUser({
      //   username: 'admin',
      //   authorities: [
      //     'ROLE_USRMNT_VISUALIZACION',
      //     'ROLE_USRMNT_CREAR_USUARIO',
      //     'ROLE_USRMNT_MODIFICAR_USUARIO',
      //     'ROLE_USRMNT_ELIMINAR_USUARIO',

      //     'ROLE_CIT_VISUALIZACION',
      //     'ROLE_CIT_CREAR_TICKET',
      //     'ROLE_CIT_MODIFICAR_TICKET',
      //     'ROLE_CIT_ELIMINAR_TICKET',
      //     'ROLE_CIT_VIS_HISTORICO',
      //     'ROLE_CIT_EXPORTAR_TICKETS',

      //     'ROLE_ORG_VISUALIZACION',
      //     'ROLE_ORG_CREAR_ORGANIZACION',
      //     'ROLE_ORG_ELIMINAR_ORGANIZACION',
      //     'ROLE_ORG_MODIFICAR_ORGANIZACION',
      //     'ROLE_ORG_VIS_HISTORICO',
      //     'ROLE_ORG_EXPORTAR_ORGANIZACIONES',

      //     'ROLE_CAT_VISUALIZACION',
      //     'ROLE_CAT_CREAR_ACTIVO',
      //     'ROLE_CAT_ELIMINAR_ACTIVO',
      //     'ROLE_CAT_MODIFICAR_ACTIVO',
      //     'ROLE_CAT_VIS_HISTORICO',
      //     'ROLE_CAT_EXPORTAR_ACTIVOS',

      //     'ROLE_PED_VISUALIZACION',
      //     'ROLE_PED_CREAR_TICKET',
      //     'ROLE_PED_ELIMINAR_TICKET',
      //     'ROLE_PED_MODIFICAR_TICKET',
      //     'ROLE_PED_VIS_HISTORICO',
      //     'ROLE_PED_EXPORTAR_TICKET',

      //     'ROLE_PORT_VISUALIZACION',
      //     'ROLE_PORT_CREAR_TICKET',
      //     'ROLE_PORT_ELIMINAR_TICKET',
      //     'ROLE_PORT_MODIFICAR_TICKET',
      //     'ROLE_PORT_VIS_HISTORICO',
      //     'ROLE_PORT_EXPORTAR_TICKET',

      //     'ROLE_PSEDE_VISUALIZACION',
      //     'ROLE_PSEDE_CREAR_TICKET',
      //     'ROLE_PSEDE_ELIMINAR_TICKET',
      //     'ROLE_PSEDE_MODIFICAR_TICKET',
      //     'ROLE_PSEDE_VIS_HISTORICO',
      //     'ROLE_PSEDE_EXPORTAR_TICKET',

      //     'ROLE_PDETAL_VISUALIZACION',
      //     'ROLE_PDETAL_CREAR_TICKET',
      //     'ROLE_PDETAL_ELIMINAR_TICKET',
      //     'ROLE_PDETAL_MODIFICAR_TICKET',
      //     'ROLE_PDETAL_VIS_HISTORICO',
      //     'ROLE_PDETAL_EXPORTAR_TICKET',

      //     'ROLE_VIS_VISUALIZACION',
      //     'ROLE_VIS_CREAR_TICKET',
      //     'ROLE_VIS_ELIMINAR_TICKET',
      //     'ROLE_VIS_MODIFICAR_TICKET',
      //     'ROLE_VIS_VIS_HISTORICO',
      //     'ROLE_VIS_EXPORTAR_TICKET',

      //     'ROLE_AUT_VISUALIZACION',
      //     'ROLE_AUT_CREAR_EDC',
      //     'ROLE_AUT_CREAR_EINTERMEDIO',
      //     'ROLE_AUT_GENERAR_INFORME'
      //   ]
      // });
    });
  }

  getUser(): User {
    return this.user;
  }

  setUser(user) {
    return (this.user = user);
  }

  isAuthenticated(): boolean {
    return !!this.user;
  }

  hasAuthority(authority: string): boolean {
    return !!this.user.authorities.find(a => a === authority);
  }

  hasAnyAuthority(authorities: string[] | string): boolean {
    /* En caso de llegar un string, lo pasamos a array */
    if (!(authorities instanceof Array)) {
      authorities = [authorities];
    }

    if (this.user) {
      return this.hasAnyAuthorityCheck(authorities);
    } else {
      console.warn('No existe información del usuario. No es posible obtener sus roles.');
    }
  }

  hasAnyAuthorityCheck(authorities: string[]): boolean {
    return !!authorities.find(authority => this.hasAuthority(authority));
  }

  authenticationChanges$(): Observable<User> {
    return this.authenticationService.currentUser;
  }

  resolve(): string[] {
    return this.user ? this.user.authorities : [];
  }

}
